import React, { useEffect, useState } from "react";
import bgImage from "../../Images/Section (2).png";
import ContestImage from "../../Images/Online test-amico 1.svg";
import { Link } from "react-router-dom";
import { FaArrowRightLong } from "react-icons/fa6";
function Contestpage() {
  const [slideIn, setSlideIn] = useState(false);

  useEffect(() => {
    setSlideIn(true);
  }, []);
  return (
    <div
      id="contest"
      className="w-full m-auto flex flex-col justify-center items-center py-8"
    >
      <div className=" flex items-center justify-center lg:justify-start   ">
        <p
          style={{ backgroundColor: "#EFEEFE" }}
          className="border-2 border rounded-full py-2 px-6 font-bold text-bgBlue"
        >
          Contest Time
        </p>
      </div>

      <div className="lg:w-4/5 flex flex-col lg:flex-row items-center justify-center m-auto font-poppins text-center gap-10">
        <div
          className={`lg:w-1/3 flex justify-center items-center lg:-order-1 ${
            slideIn ? "animate-slide-in-right" : ""
          }`}
        >
          <img src={ContestImage} alt="About" className="lg:w-96 w-80" />
        </div>

        <div
          className={`w-full lg:w-1/2 lg:text-start p-2 lg:p-0 lg:-order-2 order-2`}
        >
          <br />

          <h1 className="text-2xl lg:text-3xl font-bold font-poppins text-bgBlue mb-4 animate-slide-in-left">
            Challenge Your <span className="text-purple">Knowledge</span>{" "}
          </h1>
          <h1 className="text-2xl lg:text-3xl font-bold font-poppins text-bgBlue mb-4 animate-slide-in-left">
            Secure Your <span className="text-purple">Future!</span>
          </h1>

          <p className="text-sm text-bgBlue mb-6 animate-slide-in-left">
            Join our Government Exam Contest and put your skills to the test!
            Compete with the best minds and showcase your knowledge in a series
            of challenging questions designed to prepare you for real government
            exams. Whether you're a seasoned aspirant or just starting your
            journey, this contest offers you a chance to sharpen your skills,
            learn, and win exciting rewards. Step up, compete, and take one step
            closer to your dream career in government service!.{" "}
          </p>

          <div className="mt-6 ">
            <Link to={"/login"}>
              <div className="w-44 flex m-auto lg:m-0 py-2.5 justify-center items-center gap-4 rounded-full bg-purple text-white shadow-[6px_6px_#4D2C5E] transition duration-300">
                <button>Join Now</button>
                <FaArrowRightLong />
              </div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contestpage;
